/**
 * Функция принимает на вход индекс логической группы И, ИЛИ
 * и возвращает индекс второго объекта в массиве объектов фильтров по клиентам.
 * Функция потребовалась вследствие того, что на фронте
 * исключенные клиентские теги хранятся в отдельном объекте, т.к. сервер понимает
 * их наличие только при переданном в запросе свойстве IsInclude в значении false
 *
 * @param filterGroupIndex - индекс логической группы И, ИЛИ
 * @returns индекс второго объекта в массиве объектов фильтра по клиентам
 */

export const handleSecondClientObjectIndex = (filterGroupIndex: number) => {
  return (filterGroupIndex + 1) * 2 - 1;
};
